<template>
  <div ref="container" class="default-layout-container" :class="{ stretch: isStretchContent }">
    <div class="layout-title" >
      <slot name="title" />
    </div>
    <div class="layout-content">
      <slot name="content" />
    </div>
    <div class="layout-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.onStretchContent();

    window.addEventListener('resize', this.onStretchContent);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onStretchContent);
  },
  data() {
    return {
      isStretchContent: false,
    };
  },
  methods: {
    async onStretchContent() {
      if (this.$validate.isUndefined(this.$refs.container)) {
        return;
      }

      const documentHeight = document.documentElement.clientHeight;
      const listContainerHeight = this.$refs.container.clientHeight;

      this.isStretchContent = documentHeight < listContainerHeight;
    },
  },
};
</script>

<style lang="sass" scoped>
  .default-layout-container
    width: 100%
    position: relative
    padding: 20px
    background-color: #181823
    overflow-x: hidden
    overflow-y: auto
    align-self: flex-end
    box-sizing: border-box

    +respond-to('small')
      width: 480px
      margin: 0 auto
      padding: 30px
      align-self: center
      border-radius: 10px

    +respond-to('medium')
      padding: 30px

    &.stretch
      align-self: stretch
      border-radius: 0

    // @media screen and (orientation: landscape) and (max-height: 480px)
      // align-self: stretch
      // border-radius: 0

  .layout-title
    margin-bottom: 20px

    *
      font-weight: 600
      font-size: 20px
      line-height: 30px

  .layout-content
    margin-bottom: 20px
</style>
